import AdFoot from './AdFoot.vue'

export default AdFoot
